import type { FeatureRoutes } from '@/app/screens'

export default {
  screens: { dispositions: () => import('./DispositionsPage.vue') },
} satisfies FeatureRoutes
